import * as React from 'react';
import axios from '../../helpers/axios';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Container, Paper, Grid, FormControl, InputLabel, Input, Button, Avatar, Typography, Backdrop, CircularProgress, Stack } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LogoColor from '../../assets/logo-color.png';
import VGLogoColor from '../../assets/vg-logo-color.png';
// import { Container, Paper, Grid, FormControl, InputLabel, Input, Button, Avatar, Typography } from '@material-ui/core';
// import LockRounded from '@material-ui/icons/LockOutlined';

export interface IValues {
    email: string,
    password: string,
    otp: string
}
export interface IFormState {
    showLoader: boolean;
    [key: string]: any;
    values: IValues[];
    submitSuccess: boolean;
    loading: boolean;
    vgPortalURL: string;
}

class Login extends React.Component<RouteComponentProps, IFormState> {
    constructor(props: RouteComponentProps) {
        super(props);
        this.state = {
            showLoader: false,
            email: '',
            password: '',
            otp: '',
            values: [],
            loading: false,
            submitSuccess: false,
            showError: false,
            errorMessage: '',
            vgPortalURL: 'https://vg-masterv2.bintix.com'
        }
    }

    private processFormSubmission = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        this.setState({ showLoader: true });
        const formData = {
            email: this.state.email,
            password: this.state.password,
            otp: this.state.otp
        }
        this.setState({ submitSuccess: true, values: [...this.state.values, formData] });
        axios.post(`login`, formData).then((response: any) => {
            this.setState({ showLoader: false });
            if (response.data.success) {
                let data: any = response.data.data;
                localStorage.setItem('token', data.token);
                // localStorage.setItem('user', JSON.stringify(data.user));
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                setTimeout(() => {
                    // this.props.history.push('/customers');
                    window.location.reload();
                }, 100)
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            this.setState({
                submitSuccess: true,
                showError: true,
                errorMessage: error.response.data.message
            });
        });
    }

    private handleInputChanges = (e: React.FormEvent<HTMLInputElement>) => {
        e.preventDefault();
        this.setState({
            [e.currentTarget.name]: e.currentTarget.value,
        })
    }

    public render() {
        const { email, password, submitSuccess, loading, showError, errorMessage } = this.state;
        if (localStorage.getItem('token')) {
            return (
                <Redirect to="/" />
            );
        }

        const handleRequestOTP = () => {
            if (this.state.email && this.state.password) {
                this.setState({ showLoader: true });
                const body = {
                    email: this.state.email,
                    password: this.state.password
                }
                axios.post(`requestOTP`, body).then((response: any) => {
                    this.setState({ showLoader: false });
                    if (response.data.success) {
                        toast.success(response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    } else {
                        toast.error(response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.setState({
                        submitSuccess: true,
                        showError: true,
                        errorMessage: error.response.data.message
                    });
                });
            } else {
                toast.error("Please enter your email and password.", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            }
        }

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <Container maxWidth='xl'>
                    <Backdrop
                        sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1000 }}
                        open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                    >
                        <CircularProgress className='customLoader' />
                    </Backdrop>
                    <Grid container>
                        <Grid item md={3} style={{ minHeight: '600px', margin: '5% auto', }}>
                            <Paper
                                style={{
                                    backgroundColor: '#fff',
                                    padding: '20px',
                                    alignItems: 'center'
                                }}
                                elevation={3}
                            >
                                <form id={"login-form"} onSubmit={this.processFormSubmission}>
                                    <Grid container>
                                        <Grid item md={12} className='text-center mt-4 mb-4'>
                                            <img src={(window.location.origin == this.state.vgPortalURL) ? VGLogoColor : LogoColor} alt='logo' height={65} />
                                        </Grid>
                                    </Grid>
                                    <FormControl fullWidth={true} style={{ marginBottom: '17px', position: 'relative' }}>
                                        <InputLabel htmlFor='email'>Email</InputLabel>
                                        <Input type='text' id='email' onChange={(e: any) => this.handleInputChanges(e)} name="email" style={{ fontSize: '14px' }} required />
                                    </FormControl>
                                    <FormControl fullWidth={true} style={{ marginBottom: '17px', position: 'relative' }}>
                                        <InputLabel htmlFor='password'>Password</InputLabel>
                                        <Input type='password' id='password' onChange={(e: any) => this.handleInputChanges(e)} name="password" required />
                                    </FormControl>
                                    <FormControl fullWidth={true} style={{ marginBottom: '17px', position: 'relative' }} disabled={!this.state.email || !this.state.password}>
                                        <InputLabel htmlFor='otp'>OTP</InputLabel>
                                        <Input type='text' id='otp' onChange={(e: any) => this.handleInputChanges(e)} name="otp" required />
                                    </FormControl>
                                    <Stack direction="row" spacing={2}>
                                        <Button type="button" variant="contained" color="primary" size='large' style={{ marginTop: '20px', outline: 'none' }} disabled={!this.state.email || !this.state.password || this.state.otp} onClick={handleRequestOTP} fullWidth>
                                            Get OTP
                                        </Button>
                                        <Button type="submit" variant="contained" color="primary" size='large' style={{ marginTop: '20px', outline: 'none' }} disabled={!this.state.email || !this.state.password || !this.state.otp} fullWidth>
                                            Log in
                                        </Button>
                                    </Stack>
                                    {loading &&
                                        <span className="fa fa-circle-o-notch fa-spin" />
                                    }
                                </form>
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        )
    }
}
export default withRouter(Login)